<!--
---
--- Navigation Drawer for the Application
----->
<template>
  <!--<v-navigation-drawer
    :clipped="drawerClipped"
    :fixed="drawerFixed"
    :permanent="false"
    enable-resize-watcher
    :mini-variant="drawerMini"
    v-model="drawerModel"
    app
  >-->
  <v-navigation-drawer
    :clipped="drawerClipped"
    :fixed="drawerFixed"
    :permanent="false"
    enable-resize-watcher
    v-model="drawerModel"
    app
  >
    <v-list nav dense>
      <!-- Minimize Navigator -->
      <!--<v-list-item @click="toggleMiniDrawer">
        <v-list-item-avatar>
          <v-icon>aspect_ratio</v-icon>
        </v-list-item-avatar>
      </v-list-item>-->

      <!--<v-divider />-->

      <!-- Master Data -->
      <v-list-group
        class="my-navigator-lg"
        no-action
        sub-group
        prependIcon="perm_data_setting"
        v-model="masterDataActive"
      >
        <v-list-item slot="activator">
          <v-list-item-title>{{$t('message.masterData')}}</v-list-item-title>
        </v-list-item>

        <v-list-item class="my-navigator-lg-item" @click="entityHelper.setProductState(true)">
          <v-icon>{{ productIcon }}</v-icon>
          <v-list-item-content>
            <v-list-item-title>{{$t('message.productData')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item class="my-navigator-lg-item" @click="entityHelper.setServiceState(true)">
          <v-icon>{{ serviceIcon }}</v-icon>
          <v-list-item-content>
            <v-list-item-title>{{$t('message.servicesData')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item class="my-navigator-lg-item" @click="entityHelper.setCustomerState(true)">
          <v-icon>account_box</v-icon>
          <v-list-item-content>
            <v-list-item-title>{{$t('message.customerData')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item class="my-navigator-lg-item" @click="entityHelper.setLieferantState(true)">
          <v-icon>{{ lieferantIcon }}</v-icon>
          <v-list-item-content>
            <v-list-item-title>{{$t('message.lieferantenData')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item class="my-navigator-lg-item" @click="entityHelper.setUserState(true)">
          <v-icon :color="this.$store.getters.systemBarColor">mdi-account-multiple</v-icon>
          <v-list-item-content>
            <v-list-item-title>{{$t('message.userData')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

      </v-list-group>

      <!-- Inventory Data -->
      <v-list-group
        class="my-navigator-lg"
        no-action
        sub-group
        :prependIcon="batIcon"
        v-model="inventoryDataActive"
      >
        <v-list-item slot="activator">
          <v-list-item-title>{{$t('message.inventoryData')}}</v-list-item-title>
        </v-list-item>

        <v-list-item class="my-navigator-lg-item" @click="entityHelper.setFakturaState(true, $store.getters.FAKTURA_RAPPORT)">
          <v-icon>mdi-card-text-outline</v-icon>
          <v-list-item-content>
            <v-list-item-title>{{$t('message.rapporteData')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item class="my-navigator-lg-item" @click="entityHelper.setFakturaState(true, $store.getters.FAKTURA_OFFERTE)">
          <v-icon>mdi-text</v-icon>
          <v-list-item-content>
            <v-list-item-title>{{$t('message.offertenData')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item class="my-navigator-lg-item" @click="entityHelper.setFakturaState(true, $store.getters.FAKTURA_AUFTRAG)">
          <v-icon>mdi-card-text</v-icon>
          <v-list-item-content>
            <v-list-item-title>{{$t('message.auftragData')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item class="my-navigator-lg-item" @click="entityHelper.setFakturaState(true, $store.getters.FAKTURA_FAKTURA)">
          <v-icon>mdi-receipt</v-icon>
          <v-list-item-content>
            <v-list-item-title>{{$t('message.fakturaData')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item class="my-navigator-lg-item" @click="entityHelper.setFakturaState(true, $store.getters.FAKTURA_VERBUCHT)">
          <v-icon>mdi-cash-100</v-icon>
          <v-list-item-content>
            <v-list-item-title>{{$t('message.fakturaVerbuchtData')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item class="my-navigator-lg-item" @click="entityHelper.setFakturaState(true, $store.getters.FAKTURA_ARCHIV)">
          <v-icon>mdi-credit-card</v-icon>
          <v-list-item-content>
            <v-list-item-title>{{$t('message.fakturaArchivData')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item class="my-navigator-lg-item" @click="entityHelper.setWeingangState(true)">
          <v-icon>{{ weingangIcon }}</v-icon>
          <v-list-item-content>
            <v-list-item-title>{{$t('message.weingangData')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>

      <!-- Helper Data -->
      <v-list-group
        class="my-navigator-lg"
        no-action
        sub-group
        :prependIcon="data1Icon"
        v-model="helperDataActive"
      >
        <v-list-item slot="activator">
          <v-list-item-title>{{$t('message.helperData')}}</v-list-item-title>
        </v-list-item>

        <v-list-item class="my-navigator-lg-item" @click="entityHelper.setTaxState(true)">
          <v-icon>{{ data1Icon }}</v-icon>
          <v-list-item-content>
            <v-list-item-title>{{$t('message.taxesData')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item class="my-navigator-lg-item" @click="entityHelper.setWgruppeState(true)">
          <v-icon>{{ data2Icon }}</v-icon>
          <v-list-item-content>
            <v-list-item-title>{{$t('message.wgruppenData')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        
        <v-list-item class="my-navigator-lg-item" @click="entityHelper.setRabattState(true)">
          <v-icon>{{ data3Icon }}</v-icon>
          <v-list-item-content>
            <v-list-item-title>{{$t('message.rabatteData')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item class="my-navigator-lg-item" @click="entityHelper.setKonditionState(true)">
          <v-icon>{{ data4Icon }}</v-icon>
          <v-list-item-content>
            <v-list-item-title>{{$t('message.konditionenData')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item class="my-navigator-lg-item" @click="entityHelper.setFZeileState(true)">
          <v-icon>{{ data5Icon }}</v-icon>
          <v-list-item-content>
            <v-list-item-title>{{$t('message.fzeilenData')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item class="my-navigator-lg-item" @click="entityHelper.setMahntextState(true)">
          <v-icon>{{ data6Icon }}</v-icon>
          <v-list-item-content>
            <v-list-item-title>{{$t('message.mahntexteData')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item class="my-navigator-lg-item" @click="entityHelper.setBankkontoState(true)">
          <v-icon>{{ data7Icon }}</v-icon>
          <v-list-item-content>
            <v-list-item-title>{{$t('message.bankkontoData')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>

      <v-divider></v-divider>

      <!-- reporting -->
      <v-list-group
        v-show="this.authorityHelper.hasRoleAdmin()"      
        class="my-navigator-lg"
        no-action
        sub-group
        :prependIcon="reportIcon"
      >
        <v-list-item slot="activator">
          <v-list-item-title>{{$t('message.reporting')}}</v-list-item-title>
        </v-list-item>

        <v-list-item class="my-navigator-lg-item" @click="showReport('optima_log',$t('message.reportTitle'))">
          <v-icon>{{ singleReportIcon }}</v-icon>
          <v-list-item-content>
            <v-list-item-title>{{$t('message.reportTitle')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item class="my-navigator-lg-item" @click="reloadReports()">
          <v-icon>mdi-calendar-import</v-icon>
          <v-list-item-content>
            <v-list-item-title>{{$t('message.reloadReports')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item class="my-navigator-lg-item" @click="redeployReports()">
          <v-icon>mdi-calendar-import</v-icon>
          <v-list-item-content>
            <v-list-item-title>{{$t('message.redeployReports')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>

      <v-divider v-show="this.authorityHelper.hasRoleAdmin()"></v-divider>

      <!-- Data functions -->
      <v-list-group
        class="my-navigator-lg"
        no-action
        sub-group
        :prependIcon="databaseIcon"
      >
        <v-list-item slot="activator">
          <v-list-item-title>{{$t('message.database')}}</v-list-item-title>
        </v-list-item>

        <v-list-item class="my-navigator-lg-item" @click="rebuildData()">
          <v-icon>{{ rebuildDataIcon }}</v-icon>
          <v-list-item-content>
            <v-list-item-title>{{$t('message.rebuildData')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-show="this.authorityHelper.hasRoleAdmin()" class="my-navigator-lg-item" @click="resetSchema()">
          <v-icon>{{ resetSchemaIcon }}</v-icon>
          <v-list-item-content>
            <v-list-item-title>{{$t('message.resetSchema')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>

    </v-list>
  </v-navigation-drawer>
</template>

<script>
import WebService from "@/plugins/WebService";
import AuthorityHelper from "@/plugins/AuthorityHelper";
import EntityHelper from "@/plugins/EntityHelper";
import { mdiAccountCog } from '@mdi/js'
import { mdiAlphaPBox } from '@mdi/js'
import { mdiAlphaSBox } from '@mdi/js'
import { mdiBomb } from '@mdi/js'
import { mdiBoomGateAlert } from '@mdi/js'
import { mdiDatabase } from '@mdi/js'
import { mdiCircleSlice1 } from '@mdi/js'
import { mdiCircleSlice2 } from '@mdi/js'
import { mdiCircleSlice3 } from '@mdi/js'
import { mdiCircleSlice4 } from '@mdi/js'
import { mdiCircleSlice5 } from '@mdi/js'
import { mdiCircleSlice6 } from '@mdi/js'
import { mdiCircleSlice7 } from '@mdi/js'
import { mdiFilePdf } from '@mdi/js'
import { mdiFilePdfBox } from '@mdi/js'
import { mdiBat } from '@mdi/js'
import { mdiCircularSaw } from '@mdi/js';

export default {
  name: "optima-navigation-drawer",

  data: () => ({
    lieferantIcon: mdiAccountCog,
    productIcon: mdiAlphaPBox,
    serviceIcon: mdiAlphaSBox,
    weingangIcon: mdiCircularSaw,
    databaseIcon: mdiDatabase,
    resetSchemaIcon: mdiBomb,
    rebuildDataIcon: mdiBoomGateAlert,
    data1Icon: mdiCircleSlice1,
    data2Icon: mdiCircleSlice2,
    data3Icon: mdiCircleSlice3,
    data4Icon: mdiCircleSlice4,
    data5Icon: mdiCircleSlice5,
    data6Icon: mdiCircleSlice6,
    data7Icon: mdiCircleSlice7,
    reportIcon: mdiFilePdfBox,
    singleReportIcon: mdiFilePdf,
    batIcon: mdiBat,

    drawerClipped: false,
    drawerFixed: false,
    drawerMini: false,
    masterDataActive: false,
    helperDataActive: false,
    inventoryDataActive: false,

    webService: null,
    authorityHelper: null,
    entityHelper: null
  }),

  created() {
    this.webService = new WebService(this);
    this.authorityHelper=new AuthorityHelper(this);
    this.entityHelper = new EntityHelper(this);
  },

  computed: {
    drawerModel: {
      get() {
        return this.$store.state.navigationDrawer.drawer;
      },

      set(value) {
        this.$store.dispatch("setNavigationDrawer", value);
      }
    }
  },

  methods: {
    // toggles the drawer variant (mini/full)
    toggleMiniDrawer() {
      this.drawerMini = !this.drawerMini;
      if (this.drawerMini) {
        this.masterDataActive = false;
        this.helperDataActive = false;
        this.inventoryDataActive = false;
      }
    },

    // toggles the drawer type (permanent vs temporary) or shows/hides the drawer
    toggleDrawer() {
      if (this.drawerPermanent) {
        this.drawerPermanent = !this.drawerPermanent;
        // set the clipped state of the drawer and toolbar
        this.drawerClipped = true;
        this.toolbarClippedLeft = true;
      } else {
        // normal drawer
        this.drawerOpen = !this.drawerOpen;
      }
    },

    resetSchema()
    {
      this.$store.dispatch("setConfirmDialog", { showConfirmDialog: true, message: this.$t("message.confirmResetSchema"), action: "resetSchema", params: [] });
    },

    rebuildData()
    {
      this.$store.dispatch("setConfirmDialog", { showConfirmDialog: true, message: this.$t("message.confirmRebuildData"), action: "rebuildData", params: [] });
    },

    reloadReports()
    {
      this.webService.reloadReports(this.$store.getters.reloadReports);
    },

    redeployReports()
    {
      this.webService.redeployReports(this.$store.getters.redeployReports);
    },

    showReport(reportName,reportTitle)
    {
      this.$store.dispatch("setReport", { showReport: true, name: reportName, title: reportTitle,
        reportData: {
          name: reportName,
          outputType: "HTML",
          inputType: "LIST",
          parameters: [],
          dataSets: []
        }
      });
    }

  },


  watch: {
    // if we activate the master data we do not allow mini drawers
    masterDataActive: {
      immediate: true,
      // eslint-disable-next-line
      handler(newVal, oldVal) {
        if (newVal) {
          this.drawerMini = false;
        }
      }
    },

    helperDataActive: {
      immediate: true,
      // eslint-disable-next-line
      handler(newVal, oldVal) {
        if (newVal) {
          this.drawerMini = false;
        }
      }
    },

    inventoryDataActive: {
      immediate: true,
      // eslint-disable-next-line
      handler(newVal, oldVal) {
        if (newVal) {
          this.drawerMini = false;
        }
      }
    }

  }
};
</script>

<style scoped>
.my-navigator >>> label {
  font-size: 12px;
  left: 100px;
  color: black;
  margin-top: 0px;
  padding-top: 0px;
  padding-bottom: 0px;
}

.my-navigator >>> .v-input--radio-group__input {
  margin-top: 0px;
  margin-bottom: 0px;
  padding-left: 70px;
  padding-top: 0px;
  padding-bottom: 0px;
}

.my-navigator >>> .v-list__group__items {
  margin-top: 0px;
  margin-bottom: 0px;
  padding-left: 70px;
  padding-top: 0px;
  padding-bottom: 0px;
}

.v-input.my-navigator {
  margin-top: 0px;
  padding-top: 0px;
  padding-bottom: 0px;
}

.my-navigator-lg {
  position: relative;
  left: -10px;
}

.my-navigator-lg-item {
  position: relative;
  left: -30px;
}

.my-navigator-cb {
  margin-top: 0px;
  padding-top: 0px;
  padding-bottom: 0px;
  margin-bottom: 0px;
  height: 30px;
}

.my-spacer {
  min-width: 10%;
}
.my-badge {
  font-size: 12px;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-weight: 600;
  line-height: 23px;
  background: darkblue;
  color: white;
  height: 30px;
  border-radius: 100%;
  padding-left: 4px;
  padding-right: 4px;
}

.my-icon {
  padding-left: 40px;
}
</style>